export default function RankedListResponse({ data }) {
  if (!data?.items) return null;
  const { items, meta } = data;

  return (
    <div className="mt-2 w-full rounded-xl border border-gray-200 overflow-hidden bg-white">
      {meta && (
        <div className="px-4 py-2 text-[12px] text-gray-400 border-b border-gray-100">
          {meta.metric && <span>Metric: {meta.metric}</span>}
          {meta.metric && meta.period && <span className="mx-2">·</span>}
          {meta.period && <span>Period: {meta.period}</span>}
        </div>
      )}
      {items.map((item, i) => (
        <div
          key={i}
          className="flex items-center gap-3 px-4 py-[11px] border-b border-gray-100 last:border-b-0"
        >
          <div className="w-7 h-7 rounded-lg flex items-center justify-center text-[12px] font-medium shrink-0"
            style={{ background: "#EEEDFE", color: "#3C3489" }}>
            {item.rank}
          </div>
          <span className="flex-1 font-mono text-[13px] text-gray-800">
            {item.name}
          </span>
          <span className="text-[14px] font-semibold text-gray-900">
            {item.value.toLocaleString()}
          </span>
        </div>
      ))}
    </div>
  );
}